/**
 * 요청자 필드, 서명자 필드 컨텍스트 메뉴의 dataLabel 항목 표시 여부를 반환합니다.
 */
const getIsDataLabelEditable = (): boolean => {
  /**
   * 입력값 추출 시 데이터라벨을 모두에게 보이게 하기 위해 임시로 모두 true로 반환합니다.
   * 워크스페이스 이후 입력값 추출 권한이 생기면 해당 권한 여부를 반환하도록 합니다.
   */

  return true;
};

export default getIsDataLabelEditable;
